var app = angular.module('wpt', ["TopNav"]);
app.config(['$locationProvider', '$httpProvider', function ($locationProvider, $httpProvider) {
    $locationProvider.html5Mode({ enabled: true, requireBase: false });
}]);
app.provider("AsyncJSLoadProvider", function () {
    var _RequiredJSPaths = ['/includes/script/modules/rlServerConfig.js', '/includes/script/modules/RLGlobal_Variable.js'];
    var _scriptServerUrl = location.origin.toLowerCase().replace(/(^http.*:\/\/(.+\-)*)(.*?\.).*/, "$1www.reallusion.com") + '/';

    var _loadQueue = _RequiredJSPaths.map(function (path) {
        return $.getScript(_scriptServerUrl + path);
    });

    this.$get = function ($q) {
        var deferred = $q.defer();
        var self = this;
        return {
            getScript: function () {
                $.when.apply(null, _loadQueue).then(function () { deferred.resolve(); });
                return deferred.promise;
            }
        };
    };
});
app.controller('wptCtrl', ['$scope', '$location', '$rootScope', '$timeout', 'AsyncJSLoadProvider', '$http', '$q', '$window', '$sce', function ($scope, $location, $rootScope, $timeout, AsyncJSLoadProvider, $http, $q, $window, $sce) {
    AsyncJSLoadProvider.getScript()
        .then(function () {
            $scope.urlDomain = rlServerURL.MainWeb;
            $scope.apiDomain = rlServerURL.API;
            $scope.storeApiDomain = rlServerURL.Store;
            $scope.imgDomain = $scope.urlDomain;
            $scope.websiteName = "contentstore/";
            $scope.ReturnCode = {
                None: 0,
                DBError: 1,
                OperateSuccess: 2,
                OperateFail: 3,
                ParamError: 4,
                IDNoDataFound: 5,
                Expire: 6,
                NotAuth: 7,
                Repeat: 8,
                ParseError: 9,
                IOError: 10,
                Unhandled: 11
            };

            $scope.apiUrl = {
                PageView: "ContentData/v1/Pack/PageView",
                RecommendedCotent: "ContentData/v2/Pack/BuyAlsoList?RequestUrl=" + window.location.href,
                RecentlyView: "ContentData/v2/User/RecentlyView?RequestUrl=" + window.location.href,
                AddToCart: "cart.aspx"
            }

            $scope.httpType = {
                "POST": "post",
                "GET": "get"
            }

            $scope.recentlyViewData = {};
            $scope.recommandedContentData = {};

            $rootScope.Math = window.Math;

            //Add To Cart status
            var msgStatus = {
                "default": "",
                "success": "Added to Cart",
                "fail": "Please try again later."
            };
            $scope.msg = msgStatus.default;

            //functions
            var parseAndDecodeResult = function (value) {
                var decompressData = JSON.parse(LZString.decompressFromUTF16(value));
                return decompressData;
            }

            var httpFunction = function (method, url, data, header, withCredentials) {
                var deferred = $q.defer();
                $http({
                    method: method,
                    url: url,
                    data: (data == null || data == '') ? '' : data,
                    headers: (header == null || header == '') ? {} : header,
                    withCredentials: (withCredentials == null || withCredentials == '') ? false : true
                }).then(function successCallback(response) {
                    deferred.resolve(response);
                }, function errorCallback(response) {
                    deferred.reject();
                });
                return deferred.promise;
            }

            //page view: record visit record
            var recordPageView = function () {
                httpFunction($scope.httpType.POST, $scope.apiDomain + $scope.apiUrl.PageView, {RequestUrl: window.location.href}, { 'Content-Type': 'application/json; charset=utf-8' }, true).then(function (response) {

                }, function (response) {
                    console.log("ajax fail");
                });
            }


            //Recently View
            var recordRecentlyView = function () {
                httpFunction($scope.httpType.POST, $scope.apiDomain + $scope.apiUrl.RecentlyView, '', { 'Content-Type': 'application/json; charset=utf-8' }, true).then(function (response) {

                }, function (response) {
                    console.log("ajax fail");
                });
            }

            var gtmImpression = function (data, list) {
                var Products = new Array();
                $.each(data, function (i, v) {
                    Products.push({
                        "id": v.ContentID,
                        "name": v.Name,
                        "list": list,
                        "brand": $.trim(v.Author.toLowerCase()),
                        "category": v.CategoryName.replace("/", "_") + "/" + v.SubCategoryName.replace("/", "_") + "/" + v.Type.replace("/", "_"),
                        "variant": "",
                        "position": i + 1,
                        "price": ""
                    });
                });

                dataLayer.push({
                    'ecommerce': { 'impressions': undefined, 'detail': undefined },
                    'eventLabel': undefined,
                    'click': undefined
                });

                dataLayer.push({
                    'event': 'ECEvent',
                    'eventCategory': 'Ecommerce',
                    'eventAction': 'product list',
                    'ecommerce': {
                        'impressions': Products
                    }
                });
            }

            var getRecentlyView = function () {
                httpFunction($scope.httpType.GET, $scope.apiDomain + $scope.apiUrl.RecentlyView, '', { 'Content-Type': 'application/json; charset=utf-8', 'Compress-Output': 'true' }, true).then(function (response) {
                    if (response != null && ($scope.ReturnCode.OperateSuccess === response.data.ReturnCode)) {
                        $scope.recentlyViewData = parseAndDecodeResult(response.data.ReturnData);
                        gtmImpression($scope.recentlyViewData, "content page recentview");
                        $timeout(function () { $("#_loading-recently").fadeOut() }, 1000);
                        recordRecentlyView();
                    } else {
                        $("#_loading-recently").fadeOut();
                        console.log("get data fail");
                    }
                }, function (response) {
                    $("#_loading-recently").fadeOut();
                    console.log("ajax fail");
                });
            }

            //Recommanded Content
            var getRecommandedContent = function () {
                httpFunction($scope.httpType.GET, $scope.apiDomain + $scope.apiUrl.RecommendedCotent, '', { 'Content-Type': 'application/json; charset=utf-8', 'Compress-Output': 'true' }, true).then(function (response) {
                    if (response != null && ($scope.ReturnCode.OperateSuccess === response.data.ReturnCode)) {
                        $scope.recommandedContentData = parseAndDecodeResult(response.data.ReturnData);
                        gtmImpression($scope.recommandedContentData, "content page cross-sell");
                        $timeout(function () { $("#_loading-recommanded").fadeOut() }, 1000);
                    } else {
                        $("#_loading-recently").fadeOut();
                        console.log("get data fail");
                    }
                }, function (response) {
                    $("#_loading-recently").fadeOut();
                    console.log("ajax fail");
                });
            }

            $scope.showTooltip = function (target, message) {
                const tooltip = document.createElement('div');
                tooltip.className = 'tooltip';
                
                const arrow = document.createElement('div');
                arrow.className = 'tooltip-arrow';
                tooltip.appendChild(arrow);
                
                const messageElement = document.createElement('div');
                messageElement.className = 'tooltip-message';
                messageElement.innerText = message;
                tooltip.appendChild(messageElement);
                
                document.body.appendChild(tooltip);
    
                function removeTooltipPosClasses(element) {
                    element.className = element.className.replace(/\btooltip-pos-\S+/g, '').trim();
                }
    
                function positionTooltip() {
                    removeTooltipPosClasses(arrow);
    
                    const targetRect = target.getBoundingClientRect();
                    const tooltipRect = tooltip.getBoundingClientRect();
                    const screenPadding = 10;
                    const viewportWidth = document.documentElement.clientWidth;
                    const viewportHeight = document.documentElement.clientHeight;
    
                    let position = {
                        top: 0,
                        left: 0,
                        arrowLeft: ''
                    };
    
                    // Check available space
                    const spaceBelow = viewportHeight - targetRect.bottom - screenPadding;
                    const spaceAbove = targetRect.top - screenPadding;
                    const spaceLeft = targetRect.left - screenPadding;
                    const spaceRight = viewportWidth - targetRect.right - screenPadding;
    
                    // tooltip position
                    if (spaceBelow >= tooltipRect.height) {
                        position.top = targetRect.bottom + window.scrollY + screenPadding;
                        position.left = targetRect.left + window.scrollX + (targetRect.width / 2) - (tooltipRect.width / 2);
                        arrow.classList.add('tooltip-pos-bottom');
                    } 
                    else if (spaceAbove >= tooltipRect.height) {
                        position.top = targetRect.top + window.scrollY - tooltipRect.height - screenPadding;
                        position.left = targetRect.left + window.scrollX + (targetRect.width / 2) - (tooltipRect.width / 2);
                        arrow.classList.add('tooltip-pos-top');
                    } 
                    else if (spaceLeft >= tooltipRect.width) {
                        position.top = targetRect.top + window.scrollY + (targetRect.height / 2) - (tooltipRect.height / 2);
                        position.left = targetRect.left + window.scrollX - tooltipRect.width - screenPadding;
                        arrow.classList.add('tooltip-pos-left');
                    } 
                    else if (spaceRight >= tooltipRect.width) {
                        position.top = targetRect.top + window.scrollY + (targetRect.height / 2) - (tooltipRect.height / 2);
                        position.left = targetRect.right + window.scrollX + screenPadding;
                        arrow.classList.add('tooltip-pos-right');
                    }
    
                    // Adjust Tooltip Horizontal Position
                    if (['tooltip-pos-bottom', 'tooltip-pos-top'].includes(arrow.className.split(' ')[1])) {
                        if (position.left + tooltipRect.width > viewportWidth - screenPadding) {
                            position.left = viewportWidth - tooltipRect.width - screenPadding;
                            position.arrowLeft = (targetRect.left - position.left) + (targetRect.width / 2);
                        }
                    }
    
                    // set tooltip and arrow position
                    if (position.top !== undefined) tooltip.style.top = `${position.top}px`;
                    if (position.left !== undefined) tooltip.style.left = `${position.left}px`;
                    if (position.arrowLeft) arrow.style.left = `${position.arrowLeft}px`;
                }
    
                positionTooltip();
                tooltip.style.visibility = 'visible';
                tooltip.style.opacity = '1';
    
                setTimeout(() => {
                    tooltip.style.opacity = '0';
                    setTimeout(() => {
                        document.body.removeChild(tooltip);
                    }, 300);
                }, 1200);
            }

            $scope.addToCart = function ($event, _licenseType, buylink, csbuylink) {
                var obj = $event.currentTarget;
                //API Param
                var url = buylink || csbuylink;
                url = url.replace(/http:\/\//g, 'https://');

                if (url) {
                    httpFunction($scope.httpType.GET, url, '', { "accept": 'application/json' }, true).then(function (response) {
                        if (response.data != null && ($scope.ReturnCode.OperateSuccess === response.data.status)) {
                            $scope.showTooltip(obj, msgStatus.success);
                            if (response.data.data.TotalQty > 99) {
                                $("#cartNum").addClass('count-cart')
                                $("#cartNum").text("99");
                            }
                            else if (response.data.data.TotalQty == 0) {
                                $("#cartNum").text("");
                            } else {
                                $("#cartNum").addClass('count-cart')
                                $("#cartNum").text(response.data.data.TotalQty);
                            }
                        } else {
                            $scope.showTooltip(obj, msgStatus.fail);
                            console.log("get data fail");
                        }
                    }, function (response) {
                        $scope.showTooltip(obj, msgStatus.fail);
                        console.log("ajax fail");
                    });
                }
            }

            // initGA();
            recordPageView();
            getRecentlyView();
            getRecommandedContent();

        })
}])
    .directive('contentItem', ['$rootScope', function ($rootScope) {
        return {
            restrict: 'E',
            templateUrl: '/contentstore/include/template/contentItem-tpl.html',
            scope: {
                gaSource: '@',
                pageDataItem: '=pageData',
                contentIndex: '=contentIndex',
                pageType: '=pageType',
                imgDomain: '=imgDomain',
                websiteName: '=websiteName',
                ccdCtrlFn: '&callbackFn'
            },
            link: function ($scope, element, attrs) {
                $scope.icon_cart = '/includes/images/icon_all.svg#add_to_cart';

                $scope.isCartHover = function (_type, isHoverAction) {
                    $scope.icon_cart = '/includes/images/icon_all.svg?' 
                        + parseInt(new Date().getTime() / (1000 * 60 * 60))
                        + (isHoverAction ? '#add_to_cart_hover' : '#add_to_cart');
                }

                $scope.addToCart = function ($event) {
                    let contentBuylink = $scope.pageDataItem.BuyLink;
   
                    if ($scope.pageDataItem.AddFromID || $scope.pageDataItem.AddFromID === 0) {
                        const url = new URL(contentBuylink);
                        const params = new URLSearchParams(new URL(url).search);

                        params.set('addfrom', $scope.pageDataItem.AddFromID);

                        contentBuylink = url.origin + url.pathname + '?' + params.toString();
                    }

                    $scope.ccdCtrlFn({ 
                        contentEvent: $event,
                        contentlicenseType: undefined,
                        contentBuylink, 
                        contentCSBuylink: $scope.pageDataItem.CSBuyLink, 
                    });
                }

                //GA Tracking                
                $scope.GATrackingForProductClick = function () {
                    dataLayer.push({
                        'event': 'ECEvent',
                        'eventCategory': 'Ecommerce',
                        'eventAction': 'product click',
                        'eventLabel': undefined,
                        'ecommerce': {
                            'impressions': undefined,
                            'detail': undefined,
                            'click': {
                                'actionField': { 'list': $scope.gaSource },
                                'products': [{
                                    'id': $scope.pageDataItem.ContentID,
                                    'name': $scope.pageDataItem.Name,
                                    'brand': $.trim($scope.pageDataItem.Author.toLowerCase()),
                                    'category': $scope.pageDataItem.CategoryName.replace("/", "_") + "/" + $scope.pageDataItem.SubCategoryName.replace("/", "_") + "/" + $scope.pageDataItem.Type.replace("/", "_"),
                                    'variant': 'standard',
                                    'price': $scope.pageDataItem.Price,
                                    'qty': 1,
                                    'coupon': '',
                                    'position': $scope.contentIndex
                                }]
                            }
                        }
                    });
                }

                $scope.GATrackingForAuthorClick = function () {
                    dataLayer.push({
                        'eventCategory': 'content-store-index',
                        'eventAction': 'author',
                        'eventLabel': $scope.pageDataItem.Author,
                        'event': 'GAEvent'
                    });
                }

                $scope.encodeURIComponent = function(string) {
                    return encodeURIComponent(string);
                }
            }
        };
    }])
    .directive('slickWpt', function ($timeout) {
        return function (scope, el, attrs) {
            $timeout((function () {
                el.slick({
                    arrows: true,
                    infinite: false,
                    autoplay: false,
                    slidesToShow: 5,
                    slidesToScroll: 5,
                    dots: true,
                    responsive: [
                        {
                            breakpoint: 1140,
                            settings: {
                                slidesToShow: 4,
                                slidesToScroll: 4
                            }
                        },
                        {
                            breakpoint: 870,
                            settings: {
                                slidesToShow: 3,
                                slidesToScroll: 3
                            }
                        },
                        {
                            breakpoint: 600,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 2
                            }
                        },
                        {
                            breakpoint: 400,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1
                            }
                        }
                    ]
                })
            }), 1200)
        }
    });
    
    document.addEventListener('DOMContentLoaded', () => {
        let style = document.createElement('style');
        style.innerHTML = `
            .tooltip {
                position: absolute;
                background-color: #ffa105;
                color: #fff;
                padding: 7px 10px;
                visibility: hidden;
                opacity: 0;
                transition: opacity 0.3s;
                white-space: nowrap;
                z-index: 1000;
                font-size: calc(0.125vw + 13.6px);
                margin-left: 2px;
                text-align: center;
                font-family: roboto;
                border: none;
                min-width: 120px;
            }
            .tooltip-arrow {
                position: absolute;
                width: 0;
                height: 0;
                border-width: 5px;
                border-style: solid;
            }
            .tooltip-arrow.tooltip-pos-bottom {
                border-color: transparent transparent #ffa105 transparent;
                top: -10px;
                left: 50%;
                transform: translateX(-50%);
            }
            .tooltip-arrow.tooltip-pos-top {
                border-color: #ffa105 transparent transparent transparent;
                bottom: -10px;
                left: 50%;
                transform: translateX(-50%);
            }
            .tooltip-arrow.tooltip-pos-left {
                border-color: transparent transparent transparent #ffa105;
                top: 50%;
                right: -10px;
                transform: translateY(-50%);
            }
            .tooltip-arrow.tooltip-pos-right {
                border-color: transparent #ffa105 transparent transparent;
                top: 50%;
                left: -10px;
                transform: translateY(-50%);
            }
        `;
        document.head.appendChild(style);
    });    